/*
 * Copyright Camunda Services GmbH and/or licensed to Camunda Services GmbH under
 * one or more contributor license agreements. See the NOTICE file distributed
 * with this work for additional information regarding copyright ownership.
 * Licensed under the Camunda License 1.0. You may not use this file
 * except in compliance with the Camunda License 1.0.
 */

import { observer } from 'mobx-react';

import { processApplicationStore, milestoneStore } from 'stores';
import { publishedOn, PUBLISHED_ON } from 'utils/milestones/published-on';

import MilestoneMenu from './MilestoneMenu';
import MilestoneList from './MilestoneList';
import Milestone from './Milestone';

const MilestonesSection = ({ canCopyTo = true }) => {
  const { isLoading, isEditingMilestone, isPrimarySelected, isSecondarySelected, getAuthor, diagramMilestones, go } =
    milestoneStore;

  const { fromAProcessApplication } = processApplicationStore;

  return (
    <MilestoneList isLoading={isLoading} navigate={go}>
      {/* @ts-expect-error TS2345 */}
      {publishedOn(diagramMilestones({ fromAProcessApplication })).map((milestone) => {
        const canPublishToOrg =
          milestone.organizationPublic === false && milestone.publishedOn === PUBLISHED_ON.PROJECT;

        return (
          <Milestone
            key={milestone.id || milestone}
            milestone={milestone}
            name={milestone.name}
            description={milestone.description}
            author={getAuthor(milestone)}
            authorFullName={milestone.authorName}
            isPrimarySelection={isPrimarySelected(milestone.id)}
            isSecondarySelection={isSecondarySelected(milestone.id)}
            isEditing={isEditingMilestone(milestone.id)}
            isTemplate={milestoneStore.state?.isTemplate}
            selectMilestone={(milestoneId) => milestoneStore.select([milestoneId])}
            setEditingMilestone={milestoneStore.setEditingMilestone}
            editMilestone={(milestone, newName, newDescription) =>
              milestoneStore.edit(milestone, newName, newDescription)
            }
          >
            <MilestoneMenu milestone={milestone} canPublishToOrg={canPublishToOrg} canCopyTo={canCopyTo} />
          </Milestone>
        );
      })}
    </MilestoneList>
  );
};

export default observer(MilestonesSection);
